var map = {
	"./1.png": 2080,
	"./10.jpg": 6060,
	"./11.jpg": 2884,
	"./12.jpg": 4183,
	"./14.jpg": 2228,
	"./15.jpg": 2624,
	"./16.jpg": 8828,
	"./17.jpg": 1324,
	"./18.png": 4652,
	"./19.jpg": 724,
	"./2.jpg": 40,
	"./20.jpeg": 1680,
	"./21.jpg": 4832,
	"./3.jpg": 9368,
	"./4.jpg": 184,
	"./5.jpg": 4348,
	"./6.jpg": 3360,
	"./7.jpg": 4800,
	"./8.jpg": 2948,
	"./9.jpg": 9380,
	"./Ilana-Medina-logo.jpg": 9872,
	"./Koren-Binyamini-logo.jpg": 9216,
	"./Orly Ben David-01.jpg": 6504,
	"./Racheli-Esthetics-logo.jpg": 8432,
	"./logo liam.png": 1136,
	"./yuval logo.jpg": 8940,
	"./מזגני-עדן-logo.jpg": 3984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2740;